


































































































































































































































import { Vue, Component } from "@/shared/vuepack";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { UserPermission, FetchState, RoleType } from "@/shared/types";
import { useUserStore } from "@/shared/store/user";
import { useEmployerRolePermissionStore } from "@/admin/store/employerRolePermission";
import Pagination from "@/shared/components/ui/Pagination.vue";

const initialSearchTerms = {
  pageNumber: 1,
  pageSize: 10,
  searchFirstName: "",
  searchLastName: "",
  searchEmail: "",
  searchRole: null,
};

@Component({
  components: { Pagination },
})
export default class Add extends Vue {
  rolePermissionStore = useRolePermissionsStore();
  featureFlagStore = useFeatureFlagStore();
  employerRolePermissionStore = useEmployerRolePermissionStore();

  searchTerm = { ...initialSearchTerms };

  get userRoleOptions () {
    return this.employerRolePermissionStore.allRoles.map(x => {
      return { value: x.roleId, text: x.roleName };
    });
  }

  get canAddPermission (): boolean {
    return this.rolePermissionStore.userHasAdminPermission(
      UserPermission.AdminPortalUserManagementEdit
    );
  }

  get isLoading (): boolean {
    return this.userStore.adminSearchIsLoading;
  }

  userStore = useUserStore();
  displayName: string;

  mounted (): void {
    this.employerRolePermissionStore.getRolesByType(RoleType.Admin);
    this.searchUsers();
  }

  clearSearch () {
    this.searchTerm = { ...initialSearchTerms };
    this.searchUsers();
  }

  searchUsers () {
    this.$validator.validate().then(valid => {
      if (valid) {
        this.searchTerm.pageNumber = 1;
        this.userStore.searchAdminPortalUsers(this.searchTerm);
      }
    });
  }

  onPageChanged (event) {
    this.searchTerm.pageNumber = event;
    this.userStore.searchAdminPortalUsers(this.searchTerm);
  }

  addUser () {
    this.$router.push("/admin-users/create-admin-user");
  }
}
